import { render } from "./ClockCreate.vue?vue&type=template&id=70a11a1a&scoped=true"
import script from "./ClockCreate.vue?vue&type=script&lang=js"
export * from "./ClockCreate.vue?vue&type=script&lang=js"

import "./ClockCreate.vue?vue&type=style&index=0&id=70a11a1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a11a1a"]])

export default __exports__